export const errorTypes = {
  ALREADY_CONNECTED: 'ALREADY_CONNECTED',
  BROWSER: 'BROWSER',
  CONNECTION: 'CONNECTION',
  TIME_UP: 'TIME_UP',
  'UNEXPECTED': 'UNEXPECTED'
}